module.exports = __webpack_public_path__ + "img/venuethree-fldh.b8b74754.png";